import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import { getKitsCollections } from './queries';
import Breadcrumbs from '../../components/Breadcrumbs';
import css from './CollectionKits.module.scss';
import { Overview } from '../kit/Overview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CollectionKits = function CollectionKits(_ref) {
  var shopifyId = _ref.shopifyId;

  var _useQuery = useQuery({
    query: getKitsCollections,
    variables: {
      shopifyId: shopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      className: cc([css.fetching, css.root]),
      "aria-busy": "true"
    });
  }

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsxs("div", {
      className: css.errorRoot,
      "data-testid": "error",
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops...Something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        className: css.details,
        children: error.message
      })]
    });
  }

  var collections = data.collections.edges;
  var collection = collections[0].node;
  var title = collection.properties.banner.title;
  var kits = collection.collectionKits.map(function (item) {
    return item;
  });
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      pageTitle: title
    }), /*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: kits.map(function (item) {
        return /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx(Overview, {
            cta: item.cta,
            kit: item.kit
          })
        }, item.id);
      })
    })]
  });
};

CollectionKits.propTypes = {
  shopifyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
export default CollectionKits;